import * as React from 'react';
import { useState } from 'react';
import { translationForMts } from 'easit--localization';
import { TicketListTimeFilterModel, TicketListStateFilterModel, OfferType } from 'eTip--common';

export interface IStringFilterOption {
    key: string;
    title: string
}

export interface ITicketListFilter {
    timeFilter: TicketListTimeFilterModel;
    stateFilter: TicketListStateFilterModel;
    offerTypeFilter: OfferType;
    timeFilterOptions: IStringFilterOption[];
    stateFilterOptions: IStringFilterOption[];
    offerTypeFilterOptions: { key: number, title: string }[];
    canShowInProgress: boolean;
    onSubmitClick: (timeFilter: TicketListTimeFilterModel, stateFilter: TicketListStateFilterModel, offerTypeFilter: OfferType) => void;
}

export const TicketListFilter: React.FC<ITicketListFilter> = (props) => {
    const [timeFilter, setTimeFilter] = useState<TicketListTimeFilterModel>(props.timeFilter);
    const [stateFilter, setStateFilter] = useState<TicketListStateFilterModel>(props.stateFilter);
    const [offerTypeFilter, setOfferTypeFilter] = useState<OfferType>(props.offerTypeFilter);
    const t = translationForMts();

    return (<div className="ticket-list-filter">
        <form onSubmit={(evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            props.onSubmitClick(timeFilter, stateFilter, offerTypeFilter);
            return true;
        }}>
            <div className="filters">
                <span className="filter">
                    {t.ticketList_TimeFilterTitle}
                    <div className="filter-wrapper">
                        <select value={`${timeFilter}`} onChange={(e) => { setTimeFilter(TicketListTimeFilterModel[e.target.value]) }}>
                            {
                                props.timeFilterOptions.map(item => <option key={item.key} value={item.key}>{item.title}</option>)
                            }
                        </select>
                    </div>
                </span>


                {props.stateFilterOptions &&
                    <span className="filter">
                        {t.ticketList_StateFilterTitle}
                        <div className="filter-wrapper">
                            <select value={`${stateFilter}`} onChange={(e) => { setStateFilter(TicketListStateFilterModel[e.target.value]) }}>
                                {
                                    props.stateFilterOptions.map(item => <option key={item.key} value={item.key}>{item.title}</option>)
                                }
                            </select>
                        </div>
                    </span>
                }
                {props.offerTypeFilterOptions &&
                    <span className="filter">
                        {t.ticketList_OfferTypeFilterTitle}

                        <div className="filter-wrapper">
                            <select value={`${offerTypeFilter}`} onChange={(e) => { setOfferTypeFilter(Number(e.target.value)) }}>
                                {
                                    props.offerTypeFilterOptions.map(item => <option key={item.key} value={item.key}>{item.title}</option>)
                                }
                            </select>
                        </div>
                    </span>
                }
                {
                    __IsMTSTipos__ ?
                        <button type={"submit"} className="btn btn-primary mt-2 mt-xl-0">{t.ticketList_FilterSubmit}</button>
                        :
                        <input type={"submit"} className="btn btn-primary" value={t.ticketList_FilterSubmit} />
                }
            </div>
        </form>
    </div >);
};